export const pricesSocket = () => {
  const ws = new WebSocket(`${process.env.NEXT_PUBLIC_SOCKET_URL}prices`);

  ws.onopen = () => {
    console.log("prices socket connected");
  };
  ws.onclose = () => {
    console.log("prices socket disconnected");
  };

  return ws;
};

export const rebalancingSocket = (userId?: number | string) => {
  const ws = new WebSocket(`${process.env.NEXT_PUBLIC_SOCKET_URL}ws/${userId}`);

  ws.onopen = () => {
    console.log("rebalancing socket connected");
  };
  ws.onclose = () => {
    console.log("rebalancing socket disconnected");
  };

  return ws;
};
